import React from "react";

import { LayoutType } from "common/form/fields/layoutField/LayoutField";
import { IViewProps, View } from "core/decorators/View";
import styled, { css } from "styled-components";
import ContainerViewConfig from "./ContainerViewConfig";
import { toBlockCss } from "../../../common/views/common/BlockStylesConfig";

export interface IContainerViewProps extends IViewProps<ContainerViewConfig> {
	layoutType?: LayoutType;
	layoutIndex?: number;
}

// TODO use properly typed component
const GridItem = styled.div`

	${({type, index}: any) => type && LayoutType.COLUMN === type && css`
		grid-column: ${index + 1};
		-ms-grid-column: ${index + 1};
	`}

	${({type, index}: any) => type && LayoutType.ROW === type && css`
		grid-row: ${index + 1};
		-ms-grid-row: ${index + 1};
	`}
	
	${({config}: any) => config.maxWidth && css`
		max-width: ${config.maxWidth};
		margin: 0 auto;
	`}
	
	${({config}: any) => toBlockCss(config.blockStyles)}
` as any;

@View({id: "container-view", configClass: ContainerViewConfig})
export default class ContainerView extends React.PureComponent<IContainerViewProps> {

	public render() {
		const { children, config, layoutType, layoutIndex } = this.props;

		return (
			<GridItem config={config} type={layoutType} index={layoutIndex}>
				{children}
			</GridItem>
		);
	}
}



// WEBPACK FOOTER //
// ./src/panels/container/view/Container.view.tsx